import { Capacitor } from "@capacitor/core";
import { Purchases } from "@revenuecat/purchases-capacitor";
import { getRevenueCatApiKey } from "@/config/revenuecat";

export const ensureRevenueCatConfigured = async (): Promise<{ ok: boolean; error?: string }> => {
  if (!Capacitor.isNativePlatform()) return { ok: false, error: "Not running on a native platform" };

  const apiKey = getRevenueCatApiKey();
  if (!apiKey) {
    return {
      ok: false,
      error:
        "RevenueCat not configured: missing SDK key for this platform. (Check src/config/revenuecat.ts)",
    };
  }

  const current = await (Purchases as any).isConfigured?.().catch(() => null);
  if (current?.isConfigured === true) return { ok: true };

  try {
    await Purchases.configure({ apiKey });
  } catch (e: any) {
    return { ok: false, error: e?.message || "Failed to configure RevenueCat" };
  }

  const after = await (Purchases as any).isConfigured?.().catch(() => null);
  if (after && after.isConfigured === false) {
    return { ok: false, error: "Purchases must be configured before calling this function" };
  }

  return { ok: true };
};
